export default __webpack_public_path__ + "static/media/KOD0018-min.d4568828.webp";